module.exports = __webpack_public_path__ + "static/media/vidal-mmi-agb-verkauf-anzeigen-april-2021.7b82d9b5.pdf";